import { FoundationProject } from '@models';

export interface ProjectCommitteesResult {
  project: FoundationProject;
}
